<template>
  <TimeConstraintList
          :constrainedItem="currentClock && currentClock"
          :timeConstraintType = "timeConstraintType"
          :allowDateSelection = false
          :allowDayOfWeekSelection = false
          :allowDayOfMonthSelection = false
  />
</template>
<script>
import { mapState, mapMutation } from "vuex";
import TimeConstraintList from "@/components/common/TimeConstraintList";
import TimeConstraintApis from "@/apis/_apiTimeConstraints"
export default {
  components: { TimeConstraintList },
  computed: {
    ...mapState(["currentClock"])
  },
  data() {
    return {
      viewState: {
        showNewPanel: false
      },
      timeConstraintType: TimeConstraintApis.TIME_CONSTRAINT_TYPES.CLOCK.value
    };
  },
};
</script>
